import { DndContext, DragEndEvent, DragOverlay, DragStartEvent, PointerSensor, KeyboardSensor, useSensor, useSensors } from "@dnd-kit/core";
import { DayCalendar } from "./DayCalendar";
import { useState } from "react";
import { EventTime } from "./EventTime";
import { Event } from "../../models/calendar/Event.model";
import { EventService } from "../../services/events.api.client";
import { useEvents } from "../../contexts/calendar/EventsContext.context";
import { message } from "antd";
import { useConfig } from "../../contexts/ConfigContext";
import { useModalEvent } from "../../contexts/calendar/ModalEventContext.context";
import useAuth from "../../hooks/useAuth";
import { useCalendar } from "../../contexts/calendar/CalendarContext.context";


export const DaysGroup = ({days, month, year, isLoad, view}: {days: number[], month: number, year: number, isLoad: boolean, view:string}) => {
    /*const {options, setOptions} = useOpenModalEvent();*/
    const {events,setEvents} = useEvents();
    const {calendar} = useCalendar();
    const {setOptions} = useModalEvent();
    const [activeId, setActiveId] = useState<string|null>(null);
    const [messageApi, contextHolder] = message.useMessage();
    const {config} = useConfig();
    const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key); 
    
    // Configure sensors to distinguish between a click and a drag.
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        }),
        useSensor(KeyboardSensor)
    );
    
    const handleDragEnd = (over:DragEndEvent)=>{
        setActiveId(null);
        const id = over.active.id.toString();
        const idOver = over.over?.id.toString();
        if(!idOver) return; // Guard against clicks or invalid drops
        const originalEvent = events.filter((event:Event)=>event.id == id)[0];
        if(!originalEvent) return;
        // Early-return if the day hasn't actually changed (clicks, same-day drops)
        if(originalEvent.start?.split('T')[0]==idOver) return;
        // Work on a shallow copy so we never mutate state directly
        const currentEvent = {...originalEvent};
        const backEvent = {...originalEvent};
        currentEvent.start = `${idOver}T${currentEvent.start?.split('T')[1]}`;
        if(currentEvent.end){
          // Calculate the day difference between old start and old end,
          // then apply that same offset to the new start date for end.
          const oldStartDate = new Date(originalEvent.start.split('T')[0]);
          const oldEndDate = new Date(originalEvent.end!.split('T')[0]);
          const dayDiff = Math.round((oldEndDate.getTime() - oldStartDate.getTime()) / (24*60*60*1000));
          const newStartDate = new Date(idOver);
          newStartDate.setDate(newStartDate.getDate() + dayDiff);
          const newEndDateStr = `${newStartDate.getFullYear()}-${(newStartDate.getMonth()+1).toString().padStart(2,'0')}-${newStartDate.getDate().toString().padStart(2,'0')}`;
          currentEvent.end = `${newEndDateStr}T${currentEvent.end.split('T')[1]}`;
        }
        
        // Final guard: check if data actually changed
        if (currentEvent.start === originalEvent.start && currentEvent.end === originalEvent.end) {
            return;
        }

        let request;
        if(currentEvent.type == 'task'){
          request = {
            uid: currentEvent.uid,
            uidCompany: currentEvent.uidCompany,
            uidCalendar: currentEvent.uidCalendar,
            duration: currentEvent.duration,
            start: currentEvent.start,
            id: currentEvent.id,
            type: currentEvent.type,
            creator_enriched: currentEvent.creator_enriched
          }
        }else{
          request = {
            uid: currentEvent.uid,
            uidCompany: currentEvent.uidCompany,
            uidCalendar: currentEvent.uidCalendar,
            end: currentEvent.end,
            start: currentEvent.start,
            id: currentEvent.id,
            type: currentEvent.type,
            creator_enriched: currentEvent.creator_enriched
          }
        }
        EventService.updateEvent(request as any, currentEvent.uidCompany, currentEvent.uidCalendar, tokenData.key).then((response:Event)=>{
            setEvents((prev:Event[])=>{
                return prev.map((event:Event)=>{
                    if(event.id == response.id){
                        return currentEvent;
                    }
                    return event;
                });
            });
        }).catch((reason)=>{
            //console.error('Error al actualizar el evento:', reason);
            setEvents((prev:Event[])=>{
                return prev.map((event:Event)=>{
                    if(event.id == id){
                        return backEvent;
                    }
                    return event;
                });
            });
            messageApi.open({
              type: 'error',
              content: reason.message,
              className: 'custom-class',
              duration: 3,
            });
        })
      };
  
      const handleDragMove = ()=>{
        setOptions((prev)=>({...prev,isopen:false}))
      };

      const handleDragStart = (event:DragStartEvent) => {
        const active = event.active.id;
        setActiveId(active.toString());
      }
    return (
        <>
        {contextHolder}
        <DndContext sensors={sensors} onDragEnd={handleDragEnd} onDragMove={handleDragMove} onDragStart={handleDragStart}>
            {days.map((day, index) => (
                events&&<DayCalendar key={index} day={day} index={index} month={month} year={year} isLoad={isLoad} view={view}/>
            ))}
            <DragOverlay dropAnimation={{
              duration: 100,
              easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)',
            }}>
              {activeId ? (
                <EventTime event={events.filter((event:Event)=>event.id == activeId)[0]} key={activeId} isDay={view=="day"}/> 
              ): null}
            </DragOverlay>
        </DndContext> 
        </>
    );
}